module.exports = __webpack_public_path__ + "static/media/test9.cd0b31a6.jpeg";